import _ from 'lodash';
import {error} from '.';
import {aqfxServerBase} from '../config/environment';
import overlayConfig from '../config/overlays';
import {fetchJson} from '../utils/fetch_utils';
import {urlParams} from '../utils/security_utils';
import * as ActionTypes from './actionTypes';

const HEADERS = {
  cache: 'no-cache',
  headers: {
    'Accept': 'application/json'
  }
};

export const populateAqfxDataAsync = () => {

  const overlay = _.keyBy(overlayConfig, 'id')['AQFX'];

  if (!overlay) {
    return { type: 'DO_NOTHING' };
  }

  const { config } = overlay;
  const base = (overlay.config.base || aqfxServerBase) + (overlay.config.baseSuffix || '');

  return dispatch => {
    if (!base || !config.listService) {
      dispatch(error('Call to get AQFX data for overlay without list service configured.'));
      return;
    }

    fetchJson(_constructListServiceRequestString(base, config.listService, config.securityKey), HEADERS)
    .then(data => dispatch(_populateAqfxData(data)))
    .catch(err => dispatch(error('Call to get AQFX data failed: ' + (err.message || err))));
  };
};

const _populateAqfxData = (data) => {
  return {
    type: ActionTypes.POPULATE_AQFX_DATA,
    data: typeof data[0] !== 'undefined' ? data[0] : data
  };
};

const _constructListServiceRequestString = (base, service, securityKey) => {
  return `${base}${service}?${urlParams(service, securityKey)}`;
};



// WEBPACK FOOTER //
// ./src/actions/populate_aqfx_data.js